var _rect, _g, _path, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHours(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FFFBF2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2088_17666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7142 12.1448V12.1429C11.7142 10.4071 13.1213 9 14.8571 9H17.1428C18.8785 9 20.2857 10.4071 20.2857 12.1429V12.1448C21.8822 12.1564 22.7564 12.2382 23.3305 12.8123C24 13.4818 24 14.5593 24 16.7143V19H8V16.7143C8 14.5593 8 13.4818 8.66947 12.8123C9.24358 12.2382 10.1178 12.1564 11.7142 12.1448ZM13.4285 12.1429C13.4285 11.3539 14.0681 10.7143 14.8571 10.7143H17.1428C17.9318 10.7143 18.5714 11.3539 18.5714 12.1429L13.4285 12.1429Z",
    fill: "#E85F3D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.30595 16.6403C8.30595 16.0441 8.30621 15.6163 8.33505 15.2813C8.36356 14.9501 8.41826 14.7381 8.51081 14.5675C8.66722 14.279 8.90403 14.0422 9.19246 13.8858C9.36313 13.7933 9.57513 13.7386 9.90629 13.7101C10.2413 13.6812 10.6691 13.6809 11.2653 13.6809H20.7347C21.3309 13.6809 21.7587 13.6812 22.0937 13.7101C22.4249 13.7386 22.6369 13.7933 22.8075 13.8858C23.096 14.0422 23.3328 14.279 23.4892 14.5675C23.5817 14.7381 23.6364 14.9501 23.6649 15.2813C23.6938 15.6163 23.6941 16.0441 23.6941 16.6403V16.8036C23.6941 18.2087 23.6938 19.2442 23.6269 20.0626C23.5604 20.8775 23.4293 21.4502 23.1824 21.9346C22.7324 22.8179 22.0143 23.536 21.1311 23.986C20.6466 24.2328 20.0739 24.3639 19.2591 24.4305C18.4407 24.4974 17.4052 24.4976 16 24.4976C14.5948 24.4976 13.5593 24.4974 12.7409 24.4305C11.9261 24.3639 11.3534 24.2328 10.8689 23.986C9.9857 23.536 9.2676 22.8179 8.81757 21.9346C8.57072 21.4502 8.43963 20.8775 8.37305 20.0626C8.30619 19.2442 8.30595 18.2088 8.30595 16.8036V16.6403Z",
    fill: "#EFB6A7",
    fillOpacity: 0.47,
    stroke: "url(#paint0_linear_2088_17666)",
    strokeWidth: 0.611895
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_2088_17666)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.3438,
    y: 15.5801,
    width: 1.09803,
    height: 4.61174,
    rx: 0.549017,
    transform: "rotate(90 18.3438 15.5801)",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.099,
    y: 15.8248,
    width: 0.608517,
    height: 4.12222,
    rx: 0.304258,
    transform: "rotate(90 18.099 15.8248)",
    stroke: "url(#paint1_linear_2088_17666)",
    strokeWidth: 0.489516
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2088_17666",
    x: -4.73748,
    y: -3.73748,
    width: 41.475,
    height: 35.475,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.36874
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2088_17666"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2088_17666",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_2088_17666",
    x: 0.427156,
    y: 2.27481,
    width: 31.2219,
    height: 27.7082,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.65263
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2088_17666"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2088_17666",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2088_17666",
    x1: 6.85714,
    y1: 14.414,
    x2: 25.6659,
    y2: 28.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2088_17666",
    x1: 18.8928,
    y1: 15.5801,
    x2: 18.8928,
    y2: 20.1918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHours);
export default __webpack_public_path__ + "static/media/hours.90cb999f064a8d7ab062ad1dbdbf7006.svg";
export { ForwardRef as ReactComponent };